module.exports = __webpack_public_path__ + "static/media/logoLight.2489002c.svg";